import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-gradient-to-b from-blue-800 to-blue-900 text-white relative overflow-hidden" data-id="element-62">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-63"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-64">
        {/* Shield Icon */}
        <div className="flex justify-center mb-6" data-id="element-65">
          <div className="w-20 h-20 rounded-full bg-transparent border-4 border-orange-500 flex items-center justify-center" data-id="element-66">
            <ShieldCheck className="w-10 h-10 text-orange-500" strokeWidth={2.5} data-id="element-67" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-68">
          Garantía sin vueltas
        </h2>

        {/* Description */}
        <div className="space-y-4 text-lg text-blue-100" data-id="element-69">
          <p className="leading-relaxed" data-id="element-70">
            Estamos tan seguros de que este Programa te va a encantar, que si no
            es así, te devolvemos el 100% de tu dinero.
          </p>
          <p className="leading-relaxed" data-id="element-71">
            Tenés 7 días para probarlo sin riesgo. Si no te convence, nos
            escribís y te hacemos el reembolso. Así de simple.
          </p>
        </div>
      </div>
    </section>;
}